import { SettlementStatus } from "@libs/gateways/booking/BookingGateway.dtos.ts";

import { OWING_ICON, SETTLED_ICON } from "./BookingCalendarEvent.types.ts";

// TODO, move this somewhere else, and investigate / fix the places that wanted to show the settled icon by defualt
export const getSettledIcon = (
  settlementStatus: SettlementStatus | undefined
) => {
  if (settlementStatus === SettlementStatus.Settled) return SETTLED_ICON;
  if (settlementStatus === SettlementStatus.Owing) return OWING_ICON;
  return undefined;
};
